import {useQuery} from '@tanstack/react-query'

import {type MemberRole} from '#/state/classrooms/types'
import {STALE} from '#/state/queries'
import {useAgent} from '#/state/session'
import {classroomQuery} from './client'
import {classroomKeys} from './keys'

export function useViewerClassroomRolesQuery() {
  const agent = useAgent()
  const did = agent.session?.did
  return useQuery({
    queryKey: classroomKeys.roles(did ?? ''),
    queryFn: async () => {
      const res = await classroomQuery<{
        roles: {classroomId: string; role: MemberRole}[]
      }>(agent, 'app.taderok.classroom.getViewerRoles')
      return new Map<string, MemberRole>(
        res.roles.map(r => [r.classroomId, r.role]),
      )
    },
    staleTime: STALE.MINUTES.FIVE,
    enabled: !!did,
  })
}
